import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton } from '@material-ui/core';
import Icon from 'sharedComponents/Icon';
import BidRequestPresenter from 'presenters/BidRequestPresenter';
import LoanOfficerControlPage from 'sharedComponents/LoanOfficerControlPage';

import useStyles from './useStyles';

const ActionPage = props => {
  const classes = useStyles();
  const { bidRequest, onBack, chatUid, chatParticipant } = props;

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <IconButton onClick={onBack} className={classes.backButton}>
          <Icon name="backArrow" />
        </IconButton>
      </Box>
      <Box className={classes.paper}>
        <LoanOfficerControlPage bidRequest={bidRequest} chatUid={chatUid} chatParticipant={chatParticipant} />
      </Box>
    </Box>
  );
};

ActionPage.propTypes = {
  bidRequest: BidRequestPresenter.shape(),
  onBack: PropTypes.func.isRequired,
  chatUid: PropTypes.string.isRequired,
};

ActionPage.defaultProps = {
  bidRequest: {},
};

export default ActionPage;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/MobileMessages/components/ActionPage/ActionPage.js